import Grid from "@material-ui/core/Grid"
import {
  IconContainer,
  NavigationItemContainer,
  StyledNavigationLink,
  StyledNavigationText,
} from "components/NavigationItem/style"
import Translation from "components/Translation"
import React, { isValidElement, memo } from "react"
import { RouteComponentProps, withRouter } from "react-router-dom"

type TNavigationItem = {
  label: string
  to: string
  icon: any
} & RouteComponentProps

function NavigationExternalLink({ label, to, icon: Icon }: TNavigationItem) {
  return (
    <StyledNavigationLink href={to} target="_blank" rel="noopener noreferrer">
      <NavigationItemContainer isActive={false}>
        <Grid container={true} spacing={0}>
          {Icon && (
            <Grid item={true} xs={12}>
              <IconContainer>{isValidElement(Icon) ? Icon : <Icon />}</IconContainer>
            </Grid>
          )}
          <Grid item={true} xs={12}>
            <StyledNavigationText>
              <Translation label={label} />
            </StyledNavigationText>
          </Grid>
        </Grid>
      </NavigationItemContainer>
    </StyledNavigationLink>
  )
}

export default withRouter(memo(NavigationExternalLink))
